import { Component } from 'react';
// Composants
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCrown, faEnvelope, faPlus, faSignOutAlt, faTimes, faTrashAlt, faUser, faUserClock, faUserShield, faUsers } from '@fortawesome/pro-solid-svg-icons';
import { Button, Form, Input, Label, Message, Select } from 'semantic-ui-react';
import SubscriptionUsersLimitReachedMessage from '../../Messages/SubscriptionUsersLimitReachedMessage';
import CustomDropdown from '../../Utils/CustomDropdown';
// Librairies
import { isMobileOnly } from 'react-device-detect';
import i18n from '../../../locales/i18n';
import { connect } from 'react-redux';
import { setActiveOrganization } from '../../../actionCreators/usersActions';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'universal-cookie';
// Services
import OrganizationsService from '../../../services/OrganizationsService';
// Utils
import FormattersUtil from '../../../utils/FormattersUtil';
import DatesUtil from '../../../utils/DatesUtil';
import UsersUtil from '../../../utils/UsersUtil';
import { showToast } from '../../../utils/ToastsUtil';

const $ = (str) => FormattersUtil.getNormalizedString(str);

class OrganizationMembers extends Component {
    state = {
        searchQuery: '',
        linkedUsers: [],
        organizationAccessRequests: [],
        invitations: [],
        usersToAdd: [],
        usersOptions: [],
        notAddedUsers: null,
        isLoading: false,
        userSearch: '',
        roleUpdatingId: null, // Membre ou invitation dont le rôle est en cours d'enregistrement
        removingId: null, // Membre ou invitation en cours de retrait (évite les doubles envois)
    }

    render() {
        const { activeOrganization, loginAsData } = this.props;
        const { searchQuery, organizationAccessRequests, linkedUsers, invitations, userSearch, usersToAdd, usersOptions, notAddedUsers, isLoading } = this.state;
        const isMaxLinkedUsersReached = linkedUsers.filter(lu => !lu.isOwner).length + 1 >= activeOrganization.subscription.nbUsers;

        const userId = jwtDecode(new Cookies().get('token')).id;
        const matchesSearch = (...values) => !userSearch?.trim() || values.some(value => $(value)?.includes($(userSearch)));
        const usersToRender = linkedUsers
            .filter(user => matchesSearch(user.email, user.firstName, user.lastName))
            .sort((a, b) => (b.isOwner ? 1 : 0) - (a.isOwner ? 1 : 0) || (a.lastName || a.email || '').localeCompare(b.lastName || b.email || ''));
        const invitationsToRender = invitations.filter(invitation => invitation.status !== 'declined' && matchesSearch(invitation.email));
        const accessRequestsToRender = organizationAccessRequests.filter(ar => !invitations.find(inv => inv.id === ar.invitationId) && matchesSearch(ar.invitedEmail));

        // Le propriétaire et les admins gèrent les membres ; seul le propriétaire change les rôles
        const membership = UsersUtil.getOrganizationMembership(activeOrganization);
        const isOwner = !!membership?.isOwner;
        const canManage = isOwner || !!membership?.isAdmin;
        const organizationOwner = activeOrganization?.linkedUsers.find(user => user.isOwner);
        const nbLinkedUsers = activeOrganization?.linkedUsers?.length || 0;
        const nbInvitations = activeOrganization?.invitations?.filter(i => i.status !== 'declined')?.length || 0;

        return (
            <>
                <SubscriptionUsersLimitReachedMessage />
                {canManage && activeOrganization?.subscription?.nbUsers > 1 &&
                    <Form onSubmit={() => this.handleUsersSubmit()} error style={{ marginBottom: 'var(--spacing-md)' }}>
                        <Form.Field
                            control={Select} label={`${i18n.t("Ajouter des utilisateurs")} :`} placeholder={i18n.t("Saisissez des adresses mails")}
                            name='user' options={usersOptions} value={usersToAdd || ''} disabled={isMaxLinkedUsersReached || loginAsData?.readOnly}
                            selectOnBlur={false} multiple selection search={FormattersUtil.searchList} allowAdditions open={false} // Pour en faire un input multiple
                            searchQuery={searchQuery}
                            onSearchChange={(_, { searchQuery }) => this.setState({ searchQuery: searchQuery })} // On sauvegarde la recherche dans le state
                            onChange={this.handleChange} onKeyUp={this.handleUsersChange}
                        />
                        <Button
                            className='form-button' type='submit' color='blue' style={{ marginTop: 'var(--spacing-sm)' }}
                            disabled={isMaxLinkedUsersReached || isLoading || loginAsData?.readOnly} loading={isLoading}
                        >
                            <FontAwesomeIcon icon={faPlus} style={{ marginLeft: 0, marginRight: '10px' }} />{i18n.t("Ajouter")}
                        </Button>
                        {notAddedUsers &&
                            <Message error
                                header={`${i18n.t("Les utilisateurs suivants n'ont pas pu être ajoutés")} :`}
                                list={Object.keys(notAddedUsers).map(mail => mail + ' : ' + notAddedUsers[mail])}
                            />}
                    </Form>}
                <div style={{ display: 'flex', flexDirection: isMobileOnly ? 'column' : 'row', gap: 'var(--spacing-sm)', alignItems: 'flex-end', width: '100%', marginBottom: 'var(--spacing-md)', textAlign: isMobileOnly ? 'center' : 'left' }}>
                    <Form style={{ marginTop: 'var(--spacing-xs)', width: isMobileOnly ? '100%' : '250px' }}>
                        <Form.Field control={Input} placeholder={i18n.t("Adresse e-mail, nom, ...")} title={i18n.t("Adresse e-mail, nom, ...")} value={userSearch} onChange={(_, { value }) => this.setState({ userSearch: value })} icon='search' iconPosition='left' style={{ margin: 0 }} />
                    </Form>
                    <Label color={nbLinkedUsers ? 'blue' : undefined} style={{ display: 'flex', alignItems: 'center', justifyContent: isMobileOnly && 'center', width: isMobileOnly ? '100%' : 'auto', margin: 0, borderRadius: 'var(--radius-md)' }}>
                        <FontAwesomeIcon icon={faUser} style={{ marginRight: '10px', aspectRatio: '1/1' }} />
                        {i18n.t("{{count}} utilisateur actif", { count: nbLinkedUsers })}
                    </Label>
                    <Label color={nbInvitations ? 'blue' : undefined} style={{ display: 'flex', alignItems: 'center', justifyContent: isMobileOnly && 'center', width: isMobileOnly ? '100%' : 'auto', margin: 0, borderRadius: 'var(--radius-md)' }}>
                        <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '10px', aspectRatio: '1/1' }} />
                        {i18n.t("{{count}} invitation en attente", { count: nbInvitations })}
                    </Label>
                    {!isOwner && organizationOwner &&
                        <Button
                            color='red' type='button' className='form-button' style={{ marginLeft: 'auto' }}
                            loading={isLoading} disabled={isLoading || loginAsData?.readOnly} onClick={this.leaveSubscriptionSharing}
                        >
                            <FontAwesomeIcon icon={faSignOutAlt} style={{ marginRight: '10px' }} />
                            {i18n.t("Quitter l'organisation")}
                        </Button>}
                </div>
                <div className={`org-members${canManage ? ' org-members--manage' : ''}`}>
                    {usersToRender.length || invitationsToRender.length || accessRequestsToRender.length ?
                        <>
                            {usersToRender.length > 0 &&
                                <section className='org-members-section'>
                                    <h4 className='org-members-section__title'>{i18n.t("Membres")}<span>{usersToRender.length}</span></h4>
                                    {usersToRender.map(linkedUser => this.renderLinkedUser(linkedUser, userId, isOwner, canManage))}
                                </section>}
                            {accessRequestsToRender.length > 0 &&
                                <section className='org-members-section'>
                                    <h4 className='org-members-section__title'>{i18n.t("Demandes d'accès")}<span>{accessRequestsToRender.length}</span></h4>
                                    {accessRequestsToRender.map(accessRequest => this.renderAccessRequest(accessRequest, canManage))}
                                </section>}
                            {invitationsToRender.length > 0 &&
                                <section className='org-members-section'>
                                    <h4 className='org-members-section__title'>{i18n.t("Invitations en attente")}<span>{invitationsToRender.length}</span></h4>
                                    {invitationsToRender.map(invitation => this.renderInvitation(invitation, isOwner, canManage))}
                                </section>}
                        </>
                        : <div className='org-members-empty'>
                            <FontAwesomeIcon icon={faUsers} size='4x' />
                            <p>{i18n.t("Aucun utilisateur trouvé.")}</p>
                        </div>}
                </div>
            </>
        );
    }

    componentDidMount = () => {
        this.setState({
            organizationAccessRequests: this.props.activeOrganization.organizationAccessRequests,
            linkedUsers: this.props.activeOrganization.linkedUsers,
            invitations: this.props.activeOrganization.invitations
        });
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.activeOrganization && this.props.activeOrganization
            && (JSON.stringify(prevProps.activeOrganization.organizationAccessRequests) !== JSON.stringify(this.props.activeOrganization.organizationAccessRequests)
                || JSON.stringify(prevProps.activeOrganization.linkedUsers) !== JSON.stringify(this.props.activeOrganization.linkedUsers)
                || JSON.stringify(prevProps.activeOrganization.invitations) !== JSON.stringify(this.props.activeOrganization.invitations))
        )
            this.setState({
                organizationAccessRequests: this.props.activeOrganization.organizationAccessRequests,
                linkedUsers: this.props.activeOrganization.linkedUsers,
                invitations: this.props.activeOrganization.invitations
            });
    }

    renderIdentity = (avatar, title, subtitle, badge, isSubtitleWrapped) => (
        <div className='org-member-identity'>
            <div className='org-member-avatar'>{avatar}</div>
            <div className='org-member-identity__text'>
                <div className='org-member-identity__title'>
                    <span className='text-ellipsis' title={title}>{title}</span>
                    {badge && <div className='org-member-badge'>{badge}</div>}
                </div>
                {subtitle && <small className={isSubtitleWrapped ? undefined : 'text-ellipsis'} title={isSubtitleWrapped ? undefined : subtitle}>{subtitle}</small>}
            </div>
        </div>
    );

    renderLinkedUser = (linkedUser, userId, isOwner, canManage) => {
        const isCurrentUser = linkedUser.id === userId;
        // Un admin ne retire ni le propriétaire ni un autre admin ; on quitte soi-même l'organisation par le bouton dédié
        const canRemove = canManage && !isCurrentUser && !linkedUser.isOwner && (isOwner || !linkedUser.isAdmin);
        const name = [linkedUser.firstName, linkedUser.lastName].filter(Boolean).join(' '); // Prénom et nom complets
        const initials = `${linkedUser.firstName?.[0] || ''}${linkedUser.lastName?.[0] || ''}`.toUpperCase() || linkedUser.email?.[0]?.toUpperCase();

        return (
            <div key={linkedUser.id} className='gr-list-item gr-list-item--static org-member-row'>
                {this.renderIdentity(initials, name || linkedUser.email, name ? linkedUser.email : null, isCurrentUser && i18n.t("Vous"))}
                <div className='org-member-role'>
                    {this.renderRole(linkedUser, isOwner && !linkedUser.isOwner && !isCurrentUser, isAdmin => this.handleMemberRoleChange(linkedUser, isAdmin))}
                </div>
                {canManage &&
                    <div className='org-member-actions'>
                        {canRemove &&
                            <Button
                                icon color='red' title={i18n.t("Retirer l'utilisateur")} aria-label={i18n.t("Retirer l'utilisateur")}
                                disabled={this.props.loginAsData?.readOnly || this.state.removingId === linkedUser.id} loading={this.state.removingId === linkedUser.id}
                                onClick={() => this.handleRemoveLinkedUser(linkedUser)}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </Button>}
                    </div>}
            </div>
        );
    }

    // Rôle d'un membre ou d'une invitation : liste déroulante pour le propriétaire, libellé pour les autres
    renderRole = (item, isEditable, onChange) => {
        if (item.isOwner || !isEditable)
            return (
                <div className={`org-role-badge${item.isOwner || item.isAdmin ? ' org-role-badge--highlighted' : ''}`}>
                    <FontAwesomeIcon icon={item.isOwner ? faCrown : item.isAdmin ? faUserShield : faUser} />
                    {item.isOwner ? i18n.t("Propriétaire") : item.isAdmin ? i18n.t("Administrateur") : i18n.t("Membre")}
                </div>
            );

        const options = [
            { key: 'member', value: false, text: i18n.t("Membre"), icon: <FontAwesomeIcon icon={faUser} style={{ marginRight: '8px' }} /> },
            { key: 'admin', value: true, text: i18n.t("Administrateur"), icon: <FontAwesomeIcon icon={faUserShield} style={{ marginRight: '8px' }} /> }
        ];

        return (
            <CustomDropdown
                fluid selection selectOnBlur={false} selectOnNavigation={false} options={options} value={!!item.isAdmin} placeholder={i18n.t("Rôle dans l'organisation")}
                title={i18n.t("Rôle dans l'organisation")} aria-label={i18n.t("Rôle dans l'organisation")}
                loading={this.state.roleUpdatingId === item.id} disabled={!!this.state.roleUpdatingId || !this.props.isOnline || this.props.loginAsData?.readOnly}
                onChange={(_, { value }) => { if (value !== !!item.isAdmin) onChange(value); }}
            />
        );
    }

    renderAccessRequest = (accessRequest, canManage) => (
        <div key={accessRequest.id} className='gr-list-item gr-list-item--static org-member-row'>
            {this.renderIdentity(
                <FontAwesomeIcon icon={faUserClock} />, accessRequest.invitedEmail,
                `${i18n.t("Demande d'accès par {{requesterEmail}}, en attente d'une réponse du propriétaire ou d'un administrateur de l'organisation", { requesterEmail: accessRequest.requesterUser?.email })} · ${DatesUtil.convertUTCDateToLocaleDate(accessRequest.date)}`,
                null, true
            )}
            <div className='org-member-role' />
            {canManage && this.renderAccessRequestActions(accessRequest)}
        </div>
    );

    renderAccessRequestActions = (accessRequest, canDecline = true) => (
        <div className='org-member-actions'>
            <Button
                icon color='green' disabled={this.props.loginAsData?.readOnly} title={i18n.t("Accepter la demande d'accès")} aria-label={i18n.t("Accepter la demande d'accès")}
                onClick={() => this.handleDecideOrganizationAccessRequest(accessRequest, true)}
            >
                <FontAwesomeIcon icon={faCheck} />
            </Button>
            {canDecline &&
                <Button
                    icon color='red' disabled={this.props.loginAsData?.readOnly} title={i18n.t("Refuser la demande d'accès")} aria-label={i18n.t("Refuser la demande d'accès")}
                    onClick={() => this.handleDecideOrganizationAccessRequest(accessRequest, false)}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </Button>}
        </div>
    );

    renderInvitation = (invitation, isOwner, canManage) => {
        const accessRequest = this.state.organizationAccessRequests.find(ar => ar.invitationId === invitation.id);
        const status = accessRequest
            ? i18n.t("Demande d'accès par {{requesterEmail}}, en attente d'une réponse du propriétaire ou d'un administrateur de l'organisation ainsi que de l'utilisateur invité", { requesterEmail: accessRequest.requesterUser?.email })
            : i18n.t("Invité, en attente d'une réponse de sa part");

        return (
            <div key={invitation.id} className='gr-list-item gr-list-item--static org-member-row'>
                {this.renderIdentity(
                    <FontAwesomeIcon icon={faEnvelope} />, invitation.email, `${status} · ${DatesUtil.convertUTCDateToLocaleDate(invitation.date)}`, null, true
                )}
                <div className='org-member-role'>
                    {this.renderRole(invitation, isOwner, isAdmin => this.handleInvitationRoleChange(invitation, isAdmin))}
                </div>
                {canManage && (accessRequest
                    ? this.renderAccessRequestActions(accessRequest, isOwner || !invitation.isAdmin)
                    : <div className='org-member-actions'>
                        {(isOwner || !invitation.isAdmin) &&
                            <Button
                                icon color='red' title={i18n.t("Supprimer l'invitation")} aria-label={i18n.t("Supprimer l'invitation")}
                                disabled={this.props.loginAsData?.readOnly || this.state.removingId === invitation.id} loading={this.state.removingId === invitation.id}
                                onClick={() => this.handleRemoveInvitation(invitation)}
                            >
                                <FontAwesomeIcon icon={faTrashAlt} />
                            </Button>}
                    </div>)}
            </div>
        );
    }

    getFormattedValue = (value, maxValue) => maxValue !== -1 ? (value / maxValue * 100) % 1 ? ((value / maxValue * 100).toFixed(2)) : (value / maxValue * 100) : 0;
    handleRemoveLinkedUser = (userToRemove) => {
        if (this.state.removingId) return;
        this.setState({ removingId: userToRemove.id });
        OrganizationsService.removeUserFromOrganization(userToRemove.id, false).then(response => {
            this.setState({ removingId: null });
            if (!response) return;
            this.setState(prevState => ({
                linkedUsers: prevState.linkedUsers.filter(user => user.id !== userToRemove.id)
            }));

            this.props.setActiveOrganization({
                ...this.props.activeOrganization,
                linkedUsers: this.props.activeOrganization.linkedUsers.filter(user => user.id !== userToRemove.id)
            });

        });
    }

    handleMemberRoleChange = (linkedUser, isAdmin) => {
        if (this.state.roleUpdatingId) return;
        this.setState({ roleUpdatingId: linkedUser.id });
        OrganizationsService.updateMemberRole(linkedUser.id, isAdmin).then(response => {
            this.setState({ roleUpdatingId: null });
            if (!response) return;
            const { activeOrganization } = this.props;
            this.props.setActiveOrganization({
                ...activeOrganization,
                linkedUsers: activeOrganization.linkedUsers.map(user => user.id === linkedUser.id ? { ...user, isAdmin } : user),
                userOrganizations: activeOrganization.userOrganizations?.map(uo => uo.userId === linkedUser.id ? { ...uo, isAdmin } : uo)
            });
        });
    }

    handleInvitationRoleChange = (invitation, isAdmin) => {
        if (this.state.roleUpdatingId) return;
        this.setState({ roleUpdatingId: invitation.id });
        OrganizationsService.updateInvitationRole(invitation.id, isAdmin).then(response => {
            this.setState({ roleUpdatingId: null });
            if (!response) return;
            const { activeOrganization } = this.props;
            this.props.setActiveOrganization({
                ...activeOrganization,
                invitations: activeOrganization.invitations.map(i => i.id === invitation.id ? { ...i, isAdmin } : i)
            });
        });
    }

    handleRemoveInvitation = (invitation) => {
        if (this.state.removingId) return;
        this.setState({ removingId: invitation.id });
        OrganizationsService.removeInvitationFromOrganization(invitation.id).then((response) => {
            this.setState({ removingId: null });
            if (response) {
                this.setState(prevState => ({
                    invitations: prevState.invitations.filter(i => i.email !== invitation.email)
                }));

                this.props.setActiveOrganization({
                    ...this.props.activeOrganization,
                    invitations: this.props.activeOrganization.invitations.filter(i => i.email !== invitation.email)
                });

            }
        });
    }

    handleUsersSubmit = () => {
        const { searchQuery } = this.state;
        let usersToAdd = this.state.usersToAdd;
        if (FormattersUtil.checkEmail(searchQuery))
            usersToAdd = [...usersToAdd, searchQuery];
        if (usersToAdd.length > 0) {
            this.setState({ notAddedUsers: null, isLoading: true });
            OrganizationsService.addUsersToOrganization(this.props.activeOrganization.id, null, usersToAdd, UsersUtil.canManageOrganization(this.props.activeOrganization)).then(response => {
                let linkedUsers = JSON.parse(JSON.stringify(this.state.linkedUsers));
                let invitations = JSON.parse(JSON.stringify(this.state.invitations));

                if (response?.addedUsers?.length) {
                    linkedUsers.push(...response.addedUsers);
                }

                if (response?.invitations?.length) {
                    invitations = invitations.filter(i => !response.invitations.find(im => i.email === im.email))
                    invitations.push(...response.invitations);
                }

                this.props.setActiveOrganization({ ...this.props.activeOrganization, linkedUsers, invitations });
                if (response?.notAddedUsers && Object.keys(response.notAddedUsers).length > 0)
                    this.setState({ notAddedUsers: response.notAddedUsers });
                this.setState({ linkedUsers, invitations, usersToAdd: [], usersOptions: [], searchQuery: '', isLoading: false });
            });
        }
    }

    handleUsersChange = (e) => {
        if (e.keyCode === 32) { // Lorsqu'on appuie sur 'espace'
            if (FormattersUtil.checkEmail(this.state.searchQuery)) {
                this.setState(prevState => {
                    const searchQuery = prevState.searchQuery.trim();
                    return {
                        searchQuery: '', // On réinitialise la recherche
                        // On ajoute la recherche dans les options et dans les valeurs sélectionnées
                        usersToAdd: prevState.usersToAdd.find(x => x === searchQuery)
                            ? prevState.usersToAdd
                            : [...prevState.usersToAdd, searchQuery],
                        usersOptions: prevState.usersOptions.find(x => x.text === searchQuery)
                            ? prevState.usersOptions
                            : [...prevState.usersOptions, { text: searchQuery, value: searchQuery }]
                    }
                });
            } else showToast('email_not_valid');
        }
    }

    handleChange = (_, { value }) => { // Permet de gérer le 'remove' de l'input d'ajout
        this.setState({
            usersToAdd: value,
            usersOptions: value.map(x => ({ text: x, value: x }))
        });
    }

    handleDecideOrganizationAccessRequest = (organizationAccessRequest, isAccepted) => {
        OrganizationsService.decideOrganizationAccessRequest(organizationAccessRequest.id, isAccepted).then(response => {
            if (response) {
                const { linkedUser } = response;
                let invitations = JSON.parse(JSON.stringify(this.state.invitations));
                if (organizationAccessRequest.invitationId) {
                    let invitation = invitations.find(i => i.id === organizationAccessRequest.invitationId);
                    if (invitation) invitation.status = isAccepted ? 'accepted' : 'declined';
                }

                this.setState(prevState => ({
                    linkedUsers: linkedUser ? [...prevState.linkedUsers, linkedUser] : prevState.linkedUsers,
                    organizationAccessRequests: prevState.organizationAccessRequests.filter(oar => oar.id !== organizationAccessRequest.id),
                    invitations: [...invitations]
                }), () => {
                    this.props.setActiveOrganization({
                        ...this.props.activeOrganization,
                        linkedUsers: linkedUser ? [...this.props.activeOrganization.linkedUsers, linkedUser] : this.props.activeOrganization.linkedUsers,
                        organizationAccessRequests: this.props.activeOrganization.organizationAccessRequests.filter(oar => oar.id !== organizationAccessRequest.id),
                        invitations: [...invitations]
                    });
                });
            }
        });
    }

    leaveSubscriptionSharing = () => {
        const { activeOrganization } = this.props;
        const userId = jwtDecode(new Cookies().get('token')).id;

        const isOrganizationOwner = activeOrganization?.userOrganizations.find(uo => uo.isOwner && uo.userId === userId) ? true : false;
        if (isOrganizationOwner) return;

        const organization = this.props.organizations.find(o => o.id !== this.props.activeOrganization.id);
        if (!organization) return;

        OrganizationsService.removeUserFromOrganization(userId, true).then((response) => {
            if (response) {

                setTimeout(() => {
                    OrganizationsService.updateActiveOrganization(organization.id).then((response) => {
                        if (response) window.location.reload();
                    });
                }, 500);
            }
        });
    }
}

const mapStateToProps = (state) => {
    return {
        isOnline: state.isOnline,
        organizations: state.organizations,
        activeOrganization: state.activeOrganization,
        loginAsData: state.loginAsData,
    };
}

const mapDispatchToProps = {
    setActiveOrganization
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationMembers);